import {
  ADD_COLOR_SETTINGS_ITEM,
  CLEAR_COLOR_SIDEBAR,
  CLOSE_COLOR_SIDEBAR,
  CREATE_COLOR_SCHEME,
  LOAD_COLOR_SCHEME,
  OPEN_COLOR_SIDEBAR,
  REMOVE_COLOR_SETTINGS_ITEM,
  RESET_COLOR_SIDEBAR,
  SET_CURRENT_TAB_ID,
  SET_GRADIENT_VALUE,
  SET_SIDEBAR_HEADER_OPTIONS,
  UPDATE_SETTINGS_ITEM,
} from "store/constans";
import { clearColors } from "utils/builder/IScheduleLogic";
import { colorSchemeType, columnDataType } from "utils/types";

const initColorScheme = {
  colorSchemeType: colorSchemeType.conditionalColor,
  colorColumnKey: null,
  colorColumnType: null,
  colorSchemeGradientData: {
    firstValue: "#000000",
    secondValue: "#000000",
  },
  colorSchemeConditionsData: {
    isUnique: false,
    conditions: [],
  },
};

const initState = {
  isSidebarOpen: false,
  currentColumnValue: {
    value: "",
    key: "",
    type: "",
  },
  currentTabId: colorSchemeType.conditionalColor,
  currentColumnType: columnDataType.text,
  headerOptions: [],
  colorSettingsItems: [],
  gradientData: {
    firstValue: "",
    secondValue: "",
  },
  colorScheme: initColorScheme,
};

const colorSidebarReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case OPEN_COLOR_SIDEBAR:  
      if (payload.currentColumnValue.key === state.currentColumnValue.key) {
        return { ...state, ...payload };
      }
      clearColors()
      return {
        ...state,
        ...payload,
        colorSettingsItems: [],
        gradientData: {
          firstValue: "",
          secondValue: "",
        },
        colorScheme: initColorScheme,
      };
    case SET_GRADIENT_VALUE:
      return {
        ...state,
        gradientData: { ...state.gradientData, ...payload.gradientData },
      };
    case LOAD_COLOR_SCHEME:
      return payload.colorConditionState;
    case CREATE_COLOR_SCHEME:
      return { ...state, colorScheme: payload.colorScheme };
    case SET_SIDEBAR_HEADER_OPTIONS:
      return { ...state, ...payload };
    case CLOSE_COLOR_SIDEBAR:
      return { ...state, ...payload };
    case SET_CURRENT_TAB_ID:
      return { ...state, ...payload };
    case ADD_COLOR_SETTINGS_ITEM:
      return {
        ...state,
        colorSettingsItems: [...state.colorSettingsItems, payload.newItem],
      };
    case REMOVE_COLOR_SETTINGS_ITEM:
      const filterItems = state.colorSettingsItems.filter((item) => {
        return item.id !== payload.itemId;
      });

      return { ...state, colorSettingsItems: [...filterItems] };
    case UPDATE_SETTINGS_ITEM:
      const updatedItems = state.colorSettingsItems.map((item) => {
        if (item.id === payload.updatedData.id) {
          return { ...item, ...payload.updatedData };
        } else {
          return item;
        }
      });

      return {
        ...state,
        colorSettingsItems: updatedItems,
      };

    case CLEAR_COLOR_SIDEBAR:
      return {
        ...state,
        colorSettingsItems: [],
        gradientData: {
          firstValue: "",
          secondValue: "",
        },
        colorScheme: initColorScheme,
        isSidebarOpen: true,
      };
    case RESET_COLOR_SIDEBAR:
      return initState
    default:
      return state;
  }
};
export default colorSidebarReducer;
